import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const milestoneListRBAC = {
  pageID: 'd42c54ba4c03b1d60da1f0a1b5440325',
  elementID: {
    ViewMilestone: '72c0b32ede5ee9a7a8db8013efa7508b',
    CreateMilestone: '18541df18fee2edea5f7bb84c92db090',
    StatusMilestone: 'aa2ac08b94f5cba8f6e1176975c5bdd3',
    PiriorityMilestone: 'd2869f4925fbbe224fb87ff859c4aafb',
    EditMilestone: '1720d9082ef1c9a8ebde34b7157edd29',
  },
} as const

export const useMilestoneListRBACPage = createUseRBAC(milestoneListRBAC.elementID)

export type UseMilestoneListRBACPageType = ReturnType<typeof useMilestoneListRBACPage>
